import { createFileRoute } from '@tanstack/react-router'
import { edySupportCaseSearchSchema } from '@/features/edy-support-cases/filter-edy-support-cases/model/edySupportCaseSearch'
import { EdySupportCasesPage } from '@/pages/platform-users/ui/EdySupportCasesPage'

export const Route = createFileRoute('/support-cases')({
  validateSearch: edySupportCaseSearchSchema,
  component: EdySupportCasesPage,
})
